module.exports = __webpack_public_path__ + "static/media/american-coffee.664bd145.webp";